'use client';

import {SectionContentFieldsFragment} from '@common/hygraph-schema';
import {getButtons} from './Dynamic.button';
import {Stack} from '@eds-web/react';
import {ExtraProps} from '@/types/hygraph.types';
import {
	Alert,
	CardLink,
	CardLinks,
	ContentBlock,
	CatalogOfferCards,
	ProductDisclaimer,
	Text
} from '../molecules';

const getComponents = (
	components: SectionContentFieldsFragment['components'],
	extraProps?: ExtraProps
): React.ReactNode[] => {
	if (!components || !components.length) return [];

	return components.map((props, i) => {
		switch (props.__typename) {
			case 'Alert':
				return <Alert {...props} key={`components-alert-${i}`} />;

			case 'Button':
				return getButtons(props, extraProps);

			case 'CardLink':
				return <CardLink {...props} key={`components-card-link-${i}`} />;

			case 'CardLinks':
				return <CardLinks {...props} key={`components-card-links-${i}`} />;

			case 'CatalogOfferCards': {
				const otherProps = extraProps ? extraProps(props, i) : {};
				return (
					<CatalogOfferCards
						{...props}
						{...otherProps}
						key={`components-catalog-offer-card-${i}`}
					/>
				);
			}

			case 'ProductDisclaimer':
				return <ProductDisclaimer {...props} key={`components-product-disclaimer-${i}`} />;

			case 'Text': {
				const otherProps = extraProps ? extraProps(props, i) : {};
				return <Text {...props} {...otherProps} key={`components-text-${i}`} />;
			}

			default:
				throw new Error(
					`Component ${props.__typename} not yet supported. Please remove this component or build before using.`
				);
		}
	});
};

export const ContentSection = (props: SectionContentFieldsFragment & {extraProps?: ExtraProps}) => {
	return (
		<>
			{/* ConfigContent */}

			<Stack gap={24} noWrap direction="column">
				{props.masthead && <ContentBlock {...props.masthead} />}
				{getComponents(props.components, props.extraProps)}
			</Stack>
		</>
	);
};
